//
// Masonry JS
//

import Masonry from 'masonry-layout';

const elem = document.querySelectorAll('.news-masonry');
if (elem.length > 0) {
    const $ele = document.querySelector('.news-masonry');
    const msnry = new Masonry( $ele, {
        itemSelector: '.news-item',
        gutter: 0,
    });
}
